export const ORDER_BY = ['name', 'id'] as const;
